import React, { FC, HTMLAttributes } from 'react';

import * as Styles from './_tabPageHeaderWrapper.module.scss';

const TabPageHeaderWrapper: FC<HTMLAttributes<HTMLDivElement>> = ({
    children,
}) => {
    return (
        <div className={Styles['header-container']}>
            {children}
        </div>
    );
};

export default TabPageHeaderWrapper;
